<template>
  <div>
      <Teleport to="body">
    <!-- Modal -->
    <div class="modal fade" id="ShowHistoryModal" ref="modalEle" tabindex="-1" role="dialog"
         aria-labelledby="modelTitleId"
         aria-hidden="true">
      <div class="modal-dialog modal-full-width" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Historia zapotrzebowania </h5>

            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="widget-content">
              <div>
                <ejs-grid ref="requiredProjectItemsHistoryGrid" id="requiredProjectItemsHistoryGrid" height="500px"
                          :dataSource="requiredProjectItemsHistoryDataManager"
                          :allowTextWrap='false'
                          :allowExcelExport='true'
                          :allowPaging="true"
                          :allowSorting='true'
                          :allowFiltering='false'
                          :allowReordering='true'
                          :allowResizing='true'
                          :showColumnChooser='true'
                          :allowSelection='false'
                          :enablePersistence='false'
                          :pageSettings="pageSettings"
                          :filterSettings="filterOptions"
                          :selectionSettings="selectionOptions"
						  :dataBound="onDataBound"
						  :queryCellInfo="queryCellInfoEvent"
                          :headerCellInfo="headerCellInfoEvent">
                  <e-columns>
                    <e-column field="id" headerText="Lp." width="100" :isPrimaryKey="true" :visible="false"></e-column>
                    <e-column field="required_project_item_id" headerText="Nr zapotrzebowania" width="130" :isPrimaryKey="true"/>
                    <e-column field="team_name" headerTooltip="Zespół" headerText="Zespół"></e-column>
                    <e-column field="subteam_drawing_no" headerTooltip="Podzespół nr rysunku" headerText="Podzespół nr rysunku"></e-column>
                    <e-column field="article.id" headerTooltip="Nr artykułu" headerText="Nr artykułu"></e-column>
                    <e-column field="article.catalog_number" headerTooltip="Nr katalogowy" headerText="Nr katalogowy"></e-column>
                    <e-column field="article.model" headerTooltip="Model" headerText="Model"></e-column>
                    <e-column field="article.description" headerTooltip="Nazwa/Opis" headerText="Nazwa/Opis" width="200"></e-column>
                    <e-column field="article.link" headerTooltip="Link" headerText="Link" :template="'linkTemplate'"></e-column>
                    <e-column field="article.article_unit.name" headerTooltip="J.m." headerText="J.m." width="105" :dataSource="units"></e-column>
					<e-column field="article.producer.id" headerText="Producent" headerTooltip="Producent" foreignKeyValue="name" foreignKeyField="id" :dataSource="producers" :template="'artProducerTpl'"/>
                    <e-column field="quantity_required" headerTooltip="Ilość wymagana" headerText="Ilość wymagana" format="N" type="number"></e-column>
					<e-column field="suppliers_short_names" headerTooltip="Dostawcy" headerText="Dostawcy"></e-column>
                    <e-column field="created_by.name" headerTooltip="Dodany przez" headerText="Dodany przez"></e-column>
					<e-column field="quote_request_items" headerTooltip="Numery zapytań ofertowych" headerText="Nr Zap. ofert." :template="'quoteRequestsTemplate'" type="string"/>
					<e-column field="order_lists" headerTooltip="Numer zamówienia" headerText="Nr zamówienia" :template="'orderListTemplate'"></e-column>		
					<e-column field="warehouse_movements_records" headerTooltip="Dokumenty DW" headerText="DW dokumenty" :template="'dwDocumentsTemplate'"></e-column>		  
                    <e-column field="created_at" headerTooltip="Data dodania" headerText="Data dodania" type="date" format="dd.MM.yyyy H:mm:ss"></e-column>
                    <e-column field="status" headerTooltip="Status" headerText="Status"></e-column>
                    <e-column field="delivery_date" headerTooltip="Data dostawy" headerText="Data dostawy" type="date" format="dd.MM.yyyy"></e-column>
					<e-column field="inventory_status_name" headerTooltip="Status Mag." headerText="Status Mag." :template="'statusColorsTemplate'"></e-column>
                    <e-column field="production_due_date" headerTooltip="Data Prod." headerText="Data Prod." type="date" format="dd.MM.yyyy"></e-column>
                    <e-column field="lead_time" headerTooltip="Czas dostawy" headerText="Czas dostawy" type="date" format="dd.MM.yyyy"></e-column>
                    <e-column field="comments" headerTooltip="Uwagi" headerText="Uwagi" type="string"></e-column>
                    <e-column field="updated_by.name" headerTooltip="Ostatnio zmienił" headerText="Ostatnio zmienił"></e-column>
                    <e-column field="warehouse_received" headerTooltip="Magazyn" headerText="Magazyn" :filter="filterDefault"></e-column>
                    <e-column field="patent_number" headerTooltip="Nr Patentu" headerText="Nr Patentu"></e-column>
                    <e-column field="none!!!!!!" headerTooltip="Przekr. term. dost." headerText="Przekr. term. dost."></e-column>
                    <e-column :template="'quantityTemplate'" headerTooltip="Ilość do zam." headerText="Ilość do zam."></e-column>
                    <e-column field="barcode" headerTooltip="Kody kreskowe" headerText="Kody kreskowe"></e-column>
                    <e-column field="history_created_at" headerTooltip="Data zmiany" headerText="Data zmiany"></e-column>
                    <e-column field="history_created_by_name" headerTooltip="Utworzył" headerText="Utworzył"></e-column>
                  </e-columns>

                  <template v-slot:linkTemplate="{data}">
                    <a class="link link-primary" target="_blank" rel="noopener noreferrer" :href=data.article?.link>
                      {{ data.article?.link }}</a>
                  </template>

                  <template v-slot:quantityTemplate="{ data }">
                    {{ (data.numbering?.quantity || 0) * (data.quantity_required || 0) }}
                  </template>
				  <template v-slot:quoteRequestsTemplate="{ data }">
				    <template v-if="data.inventory_status_id == 8">
					  <span
					  v-for="(quoteRequest, idx) in data.quote_request_items"
					  :key="quoteRequest.id"
					  >
					  {{ quoteRequest.quote_request_number }}
					  <span v-if="idx < data.quote_request_items.length - 1">, </span>
					  </span>
				    </template>
				  </template>
				  <template v-slot:orderListTemplate="{data}">
					<template v-if="data.inventory_status_id == 1">
					<span v-for="(orderList, idx) in data.order_lists">
					  {{ orderList.order_number }}<span v-if="idx < data.order_lists.length -1">, </span>
					</span>
					</template>
				  </template>
			  
			  	  <template v-slot:statusColorsTemplate="{ data }">
				    <div class="status-cell">
					    <span
						  v-if="data.inventory_status?.bg_color"
						  class="status-color"
						  :style="{ backgroundColor: data.inventory_status?.bg_color }"
						  :title="data.inventory_status?.name"
						></span>
					  <span class="status-text">{{ data.inventory_status?.name || '' }}</span>
				    </div>
				  </template>
				
              <template v-slot:artProducerTpl="{ data }">
                <div class="cell-stack">
                  <div class="cell-main">
                    {{ resolveProducerName(data.article?.producer?.id ?? data.article?.producer_id) }}
                  </div>
                  <div v-if="hasReplacement(data)" class="cell-replacement">
                    {{
                      resolveProducerName(data.replacement?.article?.producer?.id ?? data.replacement?.article?.producer_id)
                    }}
                  </div>
                </div>
              </template>				
				<template v-slot:dwDocumentsTemplate="{ data }">
				  <div v-if="data.warehouse_movements_records?.length">
					
					<span
					  v-for="(mov, idx) in data.warehouse_movements_records"
					  :key="mov.id"
					>
					  {{ mov.document_number || mov.order_number }}
					  <span v-if="idx < data.warehouse_movements_records.length - 1">, </span>
					</span>

				  </div>
				</template>
                </ejs-grid>
              </div>

            </div>


          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              <i class="bi bi-x-square me-2"></i>Zamknij
            </button>

          </div>
        </div>
      </div>
    </div>
</Teleport>
  </div>

</template>

<script>
import {Modal} from "bootstrap";
import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  Edit,
  ExcelExport,
  Filter, ForeignKey,
  GridComponent,
  Page,
  Reorder,
  Resize,
  Sort,
  Toolbar,
  RowDD,
  VirtualScroll
} from '@syncfusion/ej2-vue-grids';
import {createElement} from "@syncfusion/ej2-base";
import {DropDownList} from "@syncfusion/ej2-dropdowns";
import {Tooltip} from "@syncfusion/ej2-popups";
import {DataManager, WebMethodAdaptor} from "@syncfusion/ej2-data";
import {usePage} from "@inertiajs/vue3";
import {MultiSelect} from "@syncfusion/ej2-vue-dropdowns";

let dropInstanceFilterUnits, delivererElem, multiSelectObj, statusElem, statusObj;

export default {
  components: {
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective
  },

  provide: {
    grid: [Page, Edit, Toolbar, ContextMenu, Sort, Filter, Reorder, Resize, ColumnChooser, ExcelExport, ForeignKey, RowDD, VirtualScroll]
  },

  props: {
    recordId: {
    type: Number,
    default: null
  },
  
    selectedProject: Number | String,
    selectedTeam: Boolean | String,
    projects: Object,
    teams: Object,
    units: Object,
    suppliers: Object,
    statuses: Object,
    categories: Object,
    producers: Object,
    warehouses: Object,
  },

  data() {
    return {
      newSelectedProjectId: this.selectedProject,
      newSelectedTeam: this.selectedTeam,
      allTeams: this.teams,
      error: null,
      requiredProjectItemsHistoryDataManager: [],
      pageSettings: {pageSize: 50, pageCount: 5, pageSizes: [10, 20, 50, 100, 200, 500, 1000]},
      selectionOptions: {checkboxOnly: true},

      requiredProjectItemsStatusesParams: {
        create: () => {
          statusElem = document.createElement('input');
          return statusElem;
        },
        read: () => {
          return statusObj.text;
        },
        destroy: () => {
          statusObj.destroy();
        },
        write: () => {
          statusObj = new DropDownList({
            dataSource: this.required_project_items_statuses,
            fields: {value: 'name', text: 'name'},
            enabled: true,
            placeholder: 'Wybierz status',
            floatLabelType: 'Never'
          });
          statusObj.appendTo(statusElem);
        }
      },

      inventoryStatusesParams: {
        create: () => {
          statusElem = document.createElement('input');
          return statusElem;
        },
        read: () => {
          return statusObj.text;
        },
        destroy: () => {
          statusObj.destroy();
        },
        write: () => {
          statusObj = new DropDownList({
            dataSource: this.inventory_statuses,
            fields: {value: 'name', text: 'name'},
            enabled: true,
            placeholder: 'Wybierz status',
            floatLabelType: 'Never'
          });
          statusObj.appendTo(statusElem);
        }
      },
	     _prevRowMap: new Map(),
  _cacheReady: false
    }
  },

  mounted() {
 this.modalObj = new Modal(this.$refs.modalEle);
  const grid = this.$refs.requiredProjectItemsHistoryGrid?.ej2Instances;
  },
  
  methods: {
onDataBound() {
  const grid = this.$refs.requiredProjectItemsHistoryGrid?.ej2Instances;
  if (!grid) return;

  const data = grid.getCurrentViewRecords();

  this._prevRowMap.clear();

  for (const row of data) {
    this._prevRowMap.set(row.id, { ...row });
  }

  this._cacheReady = true;
},
queryCellInfoEvent(args) {
  const grid = this.$refs.requiredProjectItemsHistoryGrid?.ej2Instances;
  if (!grid) return;

  const currentData = grid.currentViewData;
  if (!currentData || currentData.length === 0) return;

  const currentIndex = currentData.findIndex(row => row.id === args.data.id);
  const fieldName = args.column.field;

  // 1. Reset stylów przy ponownym renderowaniu/skrolowaniu wierszy
  args.cell.style.backgroundColor = '';
  args.cell.style.color = '';
  args.cell.style.fontWeight = '';
  args.cell.classList.remove('cell-changed');

  let previousIndex = currentIndex + 1;

  if (previousIndex >= 0 && previousIndex < currentData.length) {
    const previousRow = currentData[previousIndex];

    if (fieldName && args.data[fieldName] !== undefined && previousRow[fieldName] !== undefined) {
      
      // Funkcja pomocnicza do zamiany obiektów relacji na płaski tekst do porównania
      const getRawValue = (row, field) => {
        const val = row[field];
        if (val === null || val === undefined) return "";

        // Obsługa relacji 'Nr Zap. ofert.' (jeśli to tablica obiektów)
        if (field === 'quote_request_items' && Array.isArray(val)) {
          return val.map(item => item.quote_request_no || item.number || item.id).filter(Boolean).join(', ');
        }

        // Obsługa relacji 'Nr zamówienia'
        if (field === 'order_lists' && Array.isArray(val)) {
          return val.map(item => item.order_no || item.number || item.id).filter(Boolean).join(', ');
        }

        // Obsługa relacji 'DW dokumenty'
        if (field === 'warehouse_movements_records' && Array.isArray(val)) {
          return val.map(item => item.document_no || item.number || item.id).filter(Boolean).join(', ');
        }

        // Standardowy obiekt (np. article.id, created_by.name) - wyciągamy zagnieżdżoną wartość
        if (typeof val === 'object' && !Array.isArray(val)) {
          return JSON.stringify(val);
        }

        return String(val).trim();
      };

      let strCurrent = getRawValue(args.data, fieldName);
      let strPrevious = getRawValue(previousRow, fieldName);

      // Specjalny filtr dat (obcinanie milisekund/sekund do formatu YYYY-MM-DD HH:MM)
      const dateRegex = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}/;
      if (dateRegex.test(strCurrent) && dateRegex.test(strPrevious)) {
        strCurrent = strCurrent.substring(0, 16);
        strPrevious = strPrevious.substring(0, 16);
      }

      // 2. Bezpośrednie porównanie wyrenderowanego tekstu
      if (strCurrent !== strPrevious) {
        args.cell.style.backgroundColor = '#fff3cd';
        args.cell.style.color = '#856404';
        args.cell.style.fontWeight = 'bold';
        args.cell.classList.add('cell-changed');
      }
    }
  }
},

  getRequiredProjectItemsForProject() {

  this.requiredProjectItemsHistoryDataManager = new DataManager({
    url: route('requiredProjectItemsHistory.getList', {
      requiredProjectItem: this.recordId
    }),
    adaptor: new WebMethodAdaptor(),
    crossDomain: true,
    headers: [
      { 'X-CSRF-TOKEN': usePage().props.csrf_token },
    ],
  });

},

      hasReplacement(row) {
      // dopasuj do swojej struktury: np. row.replacement?.article lub row.replacement_article
      return !!(row && row.replacement && row.replacement.article);
    },
	
      resolveProducerName(id) {
      if (!id) return '';
      const p = this.producers?.find(x => String(x.id) === String(id));
      return p?.name ?? '';
    },
	
    updateSelectedProject(event) {
      this.newSelectedProjectId = Number(event.target.value);
      this.newSelectedTeam = null;
      this.$nextTick(() => {
        this.updateTeams()
      });

      this.$nextTick(() => {
        this.getRequiredProjectItemsForProject();
      });
    },

    updateTeams() {
      if (this.newSelectedProjectId) {
        const project = this.projects.find(project => project.id === Number(this.newSelectedProjectId));
        if (project) {
          this.allTeams = project.teams;
          this.newSelectedTeam = null;
        }
      } else {
        this.newSelectedTeam = null;
        this.allTeams = [];
      }
    },

    updateSelectedTeam(event) {
      this.newSelectedTeam = event.target.value;
      this.getRequiredProjectItemsForProject();
    },

    headerCellInfoEvent: function (args) {
      // pokazywanie tooltipów po najechanie na header
      new Tooltip(
          {
            content: args.cell.column.headerTooltip
          },
          args.node
      );
    },

show() {
    this.getRequiredProjectItemsForProject();

    if (this.modalObj) {
        this.modalObj.show();
    }
},
    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },
  }
}

</script>

<style scoped>
.status-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  width: 100%;
}

.status-color {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  flex-shrink: 0; /* 🔥 najważniejsze – kafelek nigdy nie znika */
}

.status-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0; /* 🔥 wymagane w flex żeby ellipsis działał */
}
/* Podświetlenie tła zmienionej komórki na delikatny żółty/pomarańczowy */
.e-grid .e-rowcell.cell-changed {
  background-color: #fff3cd !important;
  color: #856404 !important;
  font-weight: bold;
}
</style>